export enum ModalType {
  DELETE,
  CONFIRM
}
